import React, { useState } from "react";
import { Table2, BarChart3 } from "lucide-react";
import { useT } from "@/i18n";
import { cn } from "@/lib/utils";

/**
 * Envoltorio obligatorio de todo gráfico: sin borde exterior, título y
 * línea hairline debajo, switch a vista de tabla como ícono discreto a
 * la derecha. El acento de marca nunca es color de serie — eso vive en
 * lib/charts.js, la paleta categórica ya validada para daltonismo.
 */
export const ChartCard = ({ title, subtitle, testId, children, tableView, height = 260, actions }) => {
  const { t } = useT();
  const [showTable, setShowTable] = useState(false);

  return (
    <div data-testid={testId}>
      <div className="flex items-start justify-between gap-2 border-b border-line pb-2.5">
        <div>
          <p className="text-[13px] font-semibold text-ink">{title}</p>
          {subtitle && <p className="text-[11.5px] text-ink-tertiary">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-1.5">
          {actions}
          {tableView && (
            <button
              data-testid={`${testId}-toggle-table`}
              onClick={() => setShowTable((s) => !s)}
              className={cn(
                "flex h-7 w-7 items-center justify-center rounded-control text-ink-tertiary transition-colors hover:text-ink",
                showTable && "text-brand"
              )}
              title={showTable ? t("chart.view_chart") : t("chart.view_table")}
            >
              {showTable ? <BarChart3 className="h-3.5 w-3.5" /> : <Table2 className="h-3.5 w-3.5" />}
            </button>
          )}
        </div>
      </div>
      <div className="pt-3" style={{ minHeight: showTable ? undefined : height }}>
        {showTable && tableView ? tableView : children}
      </div>
    </div>
  );
};
